<template>
<div class="chapter">
<div class="inner_page">
<section>
<p class="titlePageTitle"><b>A Puppy’s Tale</b></p>
<p class="titlePageAuthor"><i><b>Valerie Hansen</b></i></p>
<p class="colophon"><img alt="image" src="images/logo.jpg"/></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780369700407_Title.vue?7688df98